import { Fragment } from "react/jsx-runtime";
import Hero from "../../components/Hero/Hero"; 
import AboutSection from "../../components/About/AboutSection";
import Features from "../../components/Features/Features";
import ContactSection from "../../components/Contact/ContactSection";
import HiringSection from "../../components/Hiring/HiringSection";
import Testimonial from "../../components/Testimonial/Testimonial";
import ProductSection from "../../components/Product/ProductSection";

const LandingPage = () =>{
    return(
        <Fragment>           
            <Hero/>
            <AboutSection/>
            <Features/>
            <ProductSection/>
            <Testimonial/>
            <ContactSection/>
            <HiringSection/>           
        </Fragment>
    )
}
export default LandingPage;